/**
 * @description Renders the quick links displayed in the user menu of the application navigation bar
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import useUserMenuQuickLinks from '../hooks/useUserMenuQuickLinks';

const styles = {
  menu: {
    margin: 0,
    padding: 0
  },
  header: {
    lineHeight: 1,
    padding: '0 0.5rem 0.5rem'
  },
  menuItem: {
    padding: '0.25rem 0.5rem'
  },
  link: {
    color: 'primary.main',
    display: 'block',
    fontSize: '0.875rem',
    textDecoration: 'none',
    whiteSpace: 'normal',
    width: '100%',

    '&:hover': {
      textDecoration: 'none'
    }
  }
};

const NavUserMenuLinks = ({ onSelection }) => {
  // Retrieve the links to be displayed int he quick links section
  const userLinks = useUserMenuQuickLinks();

  /**
   * Handles menu item clicks
   * @param {() => void} callback - a callback function to be run when this function is called
   */
  function handleMenuItemClick (callback) {
    onSelection();
    callback?.();
  }

  return (
    <MenuList
      sx={styles.menu}
      subheader={(
        <ListSubheader sx={styles.header}>
          Quick Links
        </ListSubheader>
      )}
    >
      {userLinks.map((entry) => (
        <MenuItem
          key={entry.label}
          sx={styles.menuItem}
          onClick={() => handleMenuItemClick(entry.onClick)}
        >
          {'onClick' in entry ? (
            <Typography sx={styles.link}>{entry.label}</Typography>
          ) : (
            <Link
              href={entry.path}
              sx={styles.link}
              reloadDocument={'reloadDocument' in entry ? true : null}
            >
              {entry.label}
            </Link>
          )}
        </MenuItem>
      ))}
      <Divider />
      <MenuItem sx={styles.menuItem}>
        <Link
          href='/logout/index'
          sx={styles.link}
          reloadDocument
        >
          Log out
        </Link>
      </MenuItem>
    </MenuList>
  );
};

NavUserMenuLinks.propTypes = {
  onSelection: PropTypes.func.isRequired
};

export default NavUserMenuLinks;
